//
// Modules
//

	// Sticky Kit

	var stickyElements = {
		init: function() {

			$('.js-sticky-element')
				.stick_in_parent(
					{
						bottoming: true,
						recalc_every: 5
					}
				);

		}
	}

	// Show / Hide

	var showHide = {
		selectors: {
			show: '.js-show',
			showObj: $('.js-show')
		},
		init: function() {

			this.selectors.showObj
				.click(
					function(event){

						var target = $(this).data('show-target'),
							group = $('[data-show-id="' + target + '"]').data('show-group');

						$('[data-show-group="' + group + '"]')
							.addClass('is-hidden');

						$('[data-show-id="' + target + '"]')
							.removeClass('is-hidden');

					}
				);

		}
	}

	// Validation

	var validation = {
		init: function() {

			$('.js-form-validate')
				.shapeValidate();

		}
	}

	// Copy Groups

	var copyGroups = {
		copyData: function(object) {

			var groupContent = '';

			var group = $(object).data('copy-group');

			$('[data-copy-group="' + group + '"]')
				.each(
					function(){

						if ($(this).is('select')) {
							var groupValue = $('option:selected', this).text();
						}
						else {
							var groupValue = $(this).val();
						}

						if (groupValue) {
							if ($(this).attr('id') == 'first-name') {
								groupContent += groupValue + ' ';
							}
							else {
								groupContent += groupValue + '<br>';
							}
						}

					}
				);

			$('[data-copy-group-output="' + group + '"]').html(groupContent);

		},
		copyCollectionData: function(object) {

			$(object)
				.find('[data-copy-group]')
				.each(
					function(){

						var group = $(this).data('copy-group');
							groupContent = $(this).html();

						$('[data-copy-group-output="' + group + '"]').html(groupContent);

					}
				);

		},
		init: function() {

			$('[data-copy-group-collection]')
				.click(
					function(event){

						copyGroups.copyCollectionData(this);

						event.preventDefault();

					}
				);

			$('[data-copy-group]')
				.keyup(
					function(){
						copyGroups.copyData(this);
					}
				);

			$('[data-copy-group]')
				.change(
					function(){
						copyGroups.copyData(this);
					}
				);

		}
	}

	// Option Rows

	var optionRows = {
		init: function(){

			$('.js-field-option-row')
				.click(
					function(){

						var optionRowSiblings = $(this).siblings(),
							optionRowInput = $(this).find('input'),
							optionRowSwitch = $(this).attr('data-field-option-switch');

						optionRowSiblings.removeClass('is-checked');
						optionRowSiblings.find('input').removeAttr('checked');

						$(this).addClass('is-checked');
						optionRowInput.prop('checked', 'checked');

						if (typeof optionRowSwitch !== typeof undefined && optionRowSwitch !== false) {

							var optionRowTarget = $(this).attr('data-field-option-switch-target');

							if (optionRowSwitch === 'show') {
								$('[data-field-option-switch-group="' + optionRowTarget + '"]')
									.removeClass('is-hidden')
							}
							else {
								$('[data-field-option-switch-group="' + optionRowTarget + '"]')
									.addClass('is-hidden');
							}

						}

					}
				);

		}
	}

	// Basket Totals

	var deliveryUpdate = {
		init: function(){

			$('.js-delivery-update')
				.click(
					function(event){

						var deliveryValue = $(this).data('delivery-update-value');
						var deliveryTotalValue = $(this).data('delivery-update-value-total');

						$('[data-delivery-update="delivery"]').text(deliveryValue);
						$('[data-delivery-update="total"]').text(deliveryTotalValue);

						event.preventDefault();

					}
				);

		}
	};

	// Form Submit

	var formSubmit = {
		init: function(){

			$('.js-form-submit')
				.click(
					function(event){

						var formId = $(this).data('form-submit');

						// if ( $('#zip-post-code').length != 0 ) {
						//
						// 	var postcode = $('#zip-post-code').val().toUpperCase(),
						// 		 postcodePrefix = postcode.split(/[0-9]/)[0],
						// 		 postcodePrefixLength = postcodePrefix.length,
						// 		 postcodeAlertTitle = 'Uhoh!',
						// 		 postcodeAlertText = 'Sorry, currently we do not deliver to your area.';
						//
						// 	if ( postcodePrefixLength == 2 ) {
						// 		var postcodeArray = ['BB', 'BL', 'PR', 'FY', 'WA', 'OL', 'WN', 'SK'];
						// 		var postcodeCheck = (postcodeArray.indexOf(postcodePrefix) > -1);
						// 	}
						//
						// 	else if ( postcodePrefixLength == 1 ) {
						// 		var postcodeArray = ['M'];
						// 		var postcodeCheck = (postcodeArray.indexOf(postcodePrefix) > -1);
						// 	}
						//
						// 	if ( postcodeCheck == true ) {
						// 		$('.js-loader').addClass('is-visible');
						// 		$('#' + formId).submit();
						// 	}
						//
						// 	else {
						// 		swal({
						// 			title: postcodeAlertTitle,
						// 			text: postcodeAlertText
						// 		});
						// 		event.preventDefault();
						// 	}
						//
						// }
						//
						// else {
						//
						// 	$('.js-loader').addClass('is-visible');
						// 	$('#' + formId).submit();
						//
						// }

						$('.js-loader')
							.addClass('is-visible')
							.delay(5000)
							.queue(

								function(next) {

									next();

									$('.js-loader')
										.removeClass('is-visible');


								}

							);



						$('#' + formId).submit();

					}
				);

		}
	}

	// Form Submit Dynamic

	var formSubmitDynamic = {
		init: function(){

			$('.js-form-submit-dynamic')
				.click(
					function(event){

						$('.js-loader').addClass('is-visible');
						$(this).closest('form').submit();

						event.preventDefault();

					}
				);

		}
	}

	// Input Format

	var inputFormat = {
		init: function(){

			$('.js-input-format-credit-card')
				.formatter(
					{
						'pattern': '{{9999}} {{9999}} {{9999}} {{9999}} {{9999}}',
						'persistent': true
					}
				);

		}
	}


	// Switch

	var checkboxSwitch = {
		change: function(object) {

			var group = object.data('checkbox-switch');

			$('[data-checkbox-switch-group="' + group + '"].is-hidden')
				.removeClass('is-hidden')
				.siblings('[data-checkbox-switch-group="' + group + '"]')
				.addClass('is-hidden');

			event.preventDefault();

		},
		init: function() {

			$('.js-checkbox-switch')
				.change(
					function(event){

						checkboxSwitch.change($(this));

					}
				);

		}
	}

// ----------------------------------------------------------------------------------------------------------------

//
// Initalise
//

	// Ready

	$(document)
		.ready(
			function(){
				stickyElements.init();
				showHide.init();
				checkboxSwitch.init();
				validation.init();
				copyGroups.init();
				optionRows.init();
				deliveryUpdate.init();
				formSubmit.init();
				formSubmitDynamic.init();
				inputFormat.init();
			}
		);

	// Resize

	$(window)
		.resize(
			function(){
			}
		);

	// Scroll

	$(window)
		.scroll(
			function(){
			}
		);
